import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Mission } from '../components/Mission';
import { Issues } from '../components/Issues';
import { Stats } from '../components/Stats';
import { Board } from '../components/Board';
import { News } from '../components/News';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-184">
      <Navbar data-id="element-185" />

      <main className="flex-grow" data-id="element-186">
        <Hero data-id="element-187" />
        <Stats data-id="element-188" />
        <Mission data-id="element-189" />
        <Issues data-id="element-190" />

        {/* Mid-page Donate Anchor */}
        <div id="donate" className="scroll-mt-24" data-id="element-191"></div>

        <Board data-id="element-192" />
        <News data-id="element-193" />
        <FinalCTA data-id="element-194" />
      </main>

      <Footer data-id="element-195" />
    </div>;
}